import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";
import { FC } from "react";

import { cn } from "@/lib/utils";

interface DragableObjectProps {
  children: React.JSX.Element;
  id: string | number;
  isCenter?: boolean;
  className?: string;
}

export const DragableObject: FC<DragableObjectProps> = ({
  id,
  isCenter = false,
  className,
  children,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
      }}
      className={cn(
        "flex gap-1 my-8",
        className,
        isDragging && "border-2 border-secondary rounded-md p-2",
        isCenter && "items-center",
      )}
    >
      <GripVertical
        className={cn("min-w-5 h-5", !isCenter && "mt-2")}
        color='gray'
        {...attributes}
        {...listeners}
      />
      {children}
    </div>
  );
};
